<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>Website Pages</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>New Website Page</li>
  </ol>
</nav>
<form *ngIf="pageForm" [hidden]="loading" [formGroup]="pageForm" class="w-100" novalidate action="javascript:void(0);">
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <div class="row">
      <div class="col-12 py-5 justify-content-between" *ngIf="lang != 'ar'">
        A webpage is a vital part of your website, allowing you to create digital content for your visitors. It can include text, images, links,
        and media such as Word documents, videos, or audio files. You can showcase your products, provide company information, and engage with your audience.
        A home page with banner images can highlight your promotions, news, or messages to your clients. By using webpages effectively, you can create a compelling
        online experience that keeps visitors engaged and informed.
      </div>
      <div class="col-12 py-5 justify-content-between" *ngIf="lang == 'ar'">
        تعد صفحة الويب جزءًا حيويًا من موقع الويب الخاص بك، مما يسمح لك بإنشاء محتوى رقمي لزوار موقعك. يمكن أن يتضمن النص والصور والروابط والوسائط مثل مستندات Word أو مقاطع الفيديو
        أو الملفات الصوتية. يمكنك عرض منتجاتك وتقديم معلومات الشركة والتفاعل مع جمهورك. يمكن للصفحة الرئيسية التي تحتوي على صور البانر أن تسلط الضوء على عروضك الترويجية
        أو أخبارك أو رسائلك الموجهة إلى عملائك. باستخدام صفحات الويب بشكل فعال، يمكنك إنشاء تجربة مقنعة عبر الإنترنت تحافظ على مشاركة الزوار وإطلاعهم على المعلومات.
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <label for="name_ar" translate>Name (Arabic)</label>
            <input [ngClass]="{'is-invalid': submitted && f.name_ar.errors }" type="text" formControlName="name_ar" class="form-control" id="name_ar" placeholder="{{'Name (Arabic)' | translate}}">
            <div *ngIf="submitted && f.name_ar.errors && f.name_ar.errors.required" class="invalid-feedback" translate>Required field</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <label for="name" translate>Name (English)</label>
            <input [ngClass]="{'is-invalid': submitted && f.name.errors }" type="text" formControlName="name" class="form-control" id="name" placeholder="{{'Name (English)' | translate}}">
            <div *ngIf="submitted && f.name.errors && f.name.errors.required" class="invalid-feedback" translate>Required field</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <label for="type" translate>Choose Page Type</label>
            <select (change)="handlePageTypeChange()" style="height: auto" [ngClass]="{'is-invalid': submitted && f.type.errors }" type="text" formControlName="type" class="form-control" id="type">
              <option value="" translate>[{{'Choose a webpage type like homepage, product page, or general page.' | translate}}]</option>
              <option value="home" translate>Home Page</option>
<!--              <option value="products" translate>Products List</option>-->
              <option value="general" translate>General Page</option>
            </select>
            <div *ngIf="submitted && f.type.errors && f.type.errors.required" class="invalid-feedback" translate>Required field</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <label for="url" translate>Webpage URL</label>
            <input [ngClass]="{'is-invalid': submitted && f.url.errors }" type="text" formControlName="url" class="form-control" id="url" placeholder="{{'URL like home, aboutUs, contactUs, products, or any url' | translate}}">
            <div *ngIf="submitted && f.url.errors && f.url.errors.required" class="invalid-feedback" translate>Required field</div>
          </div>
        </div>
      </div>
    </div>

    <!--  if the type is home page  -->
    <div class="form-row" *ngIf="pageType == 'home'">
      <div class="col-md-12 mb-4">
        <label for="name_ar" translate>Hero Banners</label>
        <app-hero-banner-form [initialData]="heroBannerServerData"></app-hero-banner-form>
      </div>
    </div>

    <hr/>

    <div class="form-row">
      <div class="col-md-12 mb-4">
        <label for="name_ar" translate>Widgets</label>
        <app-html-content [initialData]="htmlBlockServerData"></app-html-content>
      </div>
    </div>

  </div>

  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <button class="btn btn-primary" type="submit" *ngIf="!isAccountant" (click)="submitForm()" translate>Submit</button>&nbsp;
    <button class="btn btn-light-danger" type="submit" [routerLink]="['/private','webpages']" [queryParams]="{type: subAccountType, govId: subAccountGovId}" translate>Close</button>
  </div>
</form>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
